import React from "react";
import { Link } from "react-router-dom";
import logoClearBlue from "../../assets/img/logo-royal-blue.png"

function Footer(props) {
	return (
		<div>
			<footer
				className="footer-area footer-area-v4 bg-dark-blue">
				<div className="container">
					<div className="footer-area-internal">
						<div className="row">
							<div className="col-lg-4 col-md-6 col-xs-6">
								<div className="single-footer-widget footer-text-widget">
									<img src={logoClearBlue} alt="footer logo" />
									<p>We provide you with the simplest way to get your rent agreement registered offerring you a top notch experience and best affordable rates.</p>
								</div>
							</div>

							<div className="col-lg-4 col-md-6 col-xs-6 col-sm-12">
								<div className="single-footer-widget">
									<h5 className="widget-title">We Serve in Following Cities</h5>

									<div className="row">
										<div className="col-lg-6 col-md-6 col-sm-5">
											<div className="footer-widget-menu">
												<ul>
													<li>
														<Link to="/online-rent-agreement-pune">Pune</Link>
													</li>
													<li>
														<Link to="/online-rent-agreement-mumbai">Mumbai</Link>
													</li>
													<li>
														<Link to="/online-rent-agreement-nashik">Nashik</Link>
													</li>
													<li>
														<Link to="/online-rent-agreement-jalgaon">Jalgoan</Link>
													</li>
													<li>
														<Link to="/online-rent-agreement-satara">Satara</Link>
													</li>
													<li>
														<Link to="/online-rent-agreement-kolhapur">Kolhapur</Link>
													</li>
													<li>
														<Link to="/online-rent-agreement-pcmc">PCMC</Link>
													</li>
												</ul>
											</div>
										</div>
										<div className="col-lg-6 col-md-6 col-sm-5">
											<div className="footer-widget-menu">
												<ul>
													<li>
														<Link to="/online-rent-agreement-thane">Thane</Link>
													</li>
													<li>
														<Link to="/online-rent-agreement-aurangabad">Aurangabad</Link>
													</li>
													<li>
														<Link to="/online-rent-agreement-nagpur">Nagpur</Link>
													</li>
													<li>
														<Link to="/online-rent-agreement-nanded">Nanded</Link>
													</li>
													<li>
														<Link to="/online-rent-agreement-solapur">Solapur</Link>
													</li>
													<li>
														<Link to="/online-rent-agreement-latur">Latur</Link>
													</li>
													<li>
														<Link to="/online-rent-agreement-baramati">Baramati</Link>
													</li>
												</ul>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="col-lg-4 col-md-6 col-xs-6">
								<div className="single-footer-widget">
									<h5 className="widget-title">Quick Contact</h5>

									<a className="footer-contact-link" target="_blank" rel="nofollow noreferrer" href="https://goo.gl/maps/WM517YJEMfxh5JmU7">
										<i className="far fa-map-marker-alt"></i> 2, Susheetal Appt, Padma Society, Bibwewadi, Pune, Maharashtra 411037
									</a>
									<a className="footer-contact-link" target="_blank" rel="nofollow noreferrer" href="https://g.page/rent-agreement-pune?share">
										<i className="far fa-map-marker-alt"></i> 1/4 Shri Ganesh Park, Late GA Kulkarni Path, Kothrud, Pune - 411038
									</a>
									<a className="footer-contact-link" target="_blank" rel="nofollow noreferrer" href="https://goo.gl/maps/ewgYyYxcw1DhMegR9">
										<i className="far fa-map-marker-alt"></i> 1001, Dosti Vijeta, Vartak Nagar, Thane, Mumbai - 400606
									</a>

									<a className="footer-contact-link" href="tel:+918806242436">
										<i className="far fa-phone"></i> +91 8806 242436
									</a><br />
									<a className="footer-contact-link" href="mailto:info@rentagreement.co.in">
										<i className="far fa-envelope-open"></i> info@rentagreement.co.in
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="footer-copyright-area border-0">
					<div className="container">
						<div className="row align-items-center text-center">
							<div className="col-md-12 col-sm-12 ">
								<div className="footer-copyright">
									<p>All Rights Reserved.</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</footer>
		</div>
	);
}

export default Footer;
